import { Component, OnInit } from '@angular/core';
import {
  NavigationEnd,
  NavigationStart,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
} from '@angular/router';
import { NavigationService } from '@app/shared/common/navigation/navigation.service';
import { SettingsService } from '@app/shared/common/services/Authentication/settings.service';
import { WebSocketConfigService } from '@app/shared/common/services/Authentication/web-socket-config.service';
import { ConfigurationsService } from '@app/shared/common/services/Configuration/configurations.service';
import { CommonMethodsService } from '@app/shared/common/services/common-methods.service';
import { LoaderService } from '@app/shared/common/services/loader.service';
import { SignalRConnectionService } from '@app/shared/common/services/signal-r-connection.service';
import { getCurrentUser, setCurrentUser } from '@app/shared/common/utils/app-utils';
import { environment } from 'src/environments/environment';
import { AppConst } from '@app/App.const';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
  standalone:false
})
export class PageComponent implements OnInit {
  public showHeaderFooter: boolean = false;
  public showLoader: boolean = false;
  public isPermissionsLoaded: boolean = false;
  public isUserLoggedIn: boolean = false;
  public user: {
    name: string;
    email: string;
    privacyAccepted?: boolean;
    userId?: string;
  } = { name: '', email: '' };

  constructor(
    public loaderService: LoaderService,
    private settinService: SettingsService,
    private router: Router,
    private webSocketService: WebSocketConfigService,
    private SignalRConnectionService: SignalRConnectionService,
    private configService: ConfigurationsService,
    private commonService: CommonMethodsService,
    private navigationService:NavigationService,
  ) {
    // To hide header and footer from login page
    this.router.events.subscribe((event: any) => {
      if (event instanceof RouteConfigLoadStart) {
        this.showLoader = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.showLoader = false;
      }
      if (event instanceof NavigationStart) {
        //for future reference
      }
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects || event.url;
        this.showHeaderFooter = !(
          url === '/' ||
          url.includes('/login') ||
          url.includes('/privacy-notice') ||
          url.includes('/region-selection')
        );
        if(event.url.includes('access_token') && this.settinService.isUserLoggedin()){
          this.isUserLoggedIn=true
          this.loadUserDetails()
        }
        this.onEachLoad()
        // closing any tooltip remained open in previous page
        this.closeAllTooltips()
      }
    });
  }
  ngOnInit(): void {
    this.loaderService.isLoading.subscribe((data: any) => {
      this.showLoader = data;
    });
    this.onEachLoad(true)
  }
  public loadUserDetails(){
    if (environment.isBaseApplication) {
      sessionStorage.removeItem(AppConst.REGION_SELECTION_COMPLETED);
    }
    this.commonService.getUserDetails(true)?.subscribe(
      (data)=>{
        this.commonService.setIsUserDetailsLoaded(true)
        this.commonService.setPrivacyAccepted(data.privacyAccepted)
        this.user=data
        setCurrentUser(data)
        if (environment.isBaseApplication) {
          this.navigationService.navigateTo(this.navigationService.getRegionSelectionRoute)
        }
        else if(data.privacyAccepted){
          this.navigationService.navigateTo(this.navigationService.getHomePageUrl)
        }
        else{
          this.navigationService.navigateTo(this.navigationService.getPrivacyNoticeUrl)
        }
      }
    );
  }
  public closeAllTooltips() {
    const closeArray=document.querySelectorAll(
      '#custom-teams-operation-tooltip  .motif-tooltip-close-button'
    );
    closeArray.forEach((ele: any) => ele.click())

  }

  public onEachLoad(loadUserDatail:boolean=false){
    if(loadUserDatail){
      // uses this for manual reload
      this.user=getCurrentUser()
      this.isUserLoggedIn=true
      this.commonService.setPrivacyAccepted(
        this.user?.privacyAccepted === true
      )
    }
    const canLoadPermissions =
      this.commonService.getPrivacyAccepted() &&
      (!environment.isBaseApplication || this.router.url.includes('/home'));

    if (
      canLoadPermissions &&
      this.settinService.isUserLoggedin() &&
      !this.isPermissionsLoaded
    ) {
      this.isPermissionsLoaded = true;
      this.settinService.getPermissionsByModule();
      // this.WebsocketConnect();
      this.configService.getRegionConfig()
      // this.Signal
      // RConnectionService.getAllNotifications();
    }
  }

  WebsocketConnect() {
    let stompClient = this.webSocketService.connect();
    console.log(stompClient);
    console.log(stompClient?.connected);
    // stompClient.subscribe((res: any) => {
    //   console.log(res);
    // });
    stompClient.connect({}, (frame: any) => {
      console.log(frame);
      console.log(stompClient?.connected);
      // Subscribe to notification topic
      stompClient.subscribe('api/topic/signoff', (notifications: any) => {
        // Update notifications attribute with the recent messsage sent from the server
        console.log(notifications);
      });
      stompClient.subscribe('api/topic/signOff', (notifications: any) => {
        // Update notifications attribute with the recent messsage sent from the server
        console.log(notifications);
      });
      stompClient.subscribe('api/topic/topic/signOff', (notifications: any) => {
        // Update notifications attribute with the recent messsage sent from the server
        console.log(notifications);
      });
    });
  }
}
